module.exports = __webpack_public_path__ + "img/opex.4d2dc6fe.svg";